import { IconButton, Link, Menu, MenuItem, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import { DELETE, EDIT } from '../../shared/AppConstants';
import { useState } from 'react';
import { getUserName, PhaseBadges } from '../../shared/UtilFunctions';
import dayjs from 'dayjs';

export const PhaseLinksListItem = ({
  link,
  isReadOnly,
  userInfoMap,
  editEntity,
  removeEntity
}) => {
  const [menuAnchor, setMenuAnchor] = useState(null);
  const closeMenu = () => setMenuAnchor(null);
  let formatString = 'DD-MMM-YYYY [at] h:mma ZZ';

  function getDropDownItems() {
    return (
      <>
        <IconButton
          aria-label="More Actions"
          onClick={(e) => setMenuAnchor(e.currentTarget)}
        >
          <fuel-icon name={'more_vertical'} />
        </IconButton>
        <Menu
          anchorEl={menuAnchor}
          onClose={closeMenu}
          open={Boolean(menuAnchor)}
        >
          <MenuItem
            onClick={(e) => {
              editEntity(e, link);
              closeMenu();
            }}
          >
            <fuel-icon name={'edit'} />
            {EDIT}
          </MenuItem>
          <MenuItem
            onClick={(e) => {
              removeEntity(e, link);
              closeMenu();
            }}
          >
            <fuel-icon name={'delete'} />
            {DELETE}
          </MenuItem>
        </Menu>
      </>
    );
  }

  const LinkName = () => {
    return (
      <>
        <Link href={link.url} target="_blank" rel="noopener noreferrer">
          {link.url}
        </Link>
        <br></br>
      </>
    );
  };

  const Description = () => {
    return (
      <>
        {link.description && (
          <Typography variant={'bodyMedium'}>{link.description} </Typography>
        )}
      </>
    );
  };

  const FileDetails = () => {
    return (
      <>
        {link.updatedById && (
          <Typography variant="bodyMedium">
            {getUserName(link.updatedById, userInfoMap) +
              ' on ' +
              dayjs(new Date(link.updatedOn)).format(formatString)}
          </Typography>
        )}
      </>
    );
  };

  return (
    <>
      <Grid
        display={'flex'}
        justifyContent={'start'}
        paddingTop={2}
        paddingBottom={2}
      >
        {!isReadOnly && getDropDownItems()}
        <Grid>
          <LinkName />
          <FileDetails />
          <PhaseBadges file={link} />
          <Description />
        </Grid>
      </Grid>
    </>
  );
};
